import { inject, toRef } from 'vue';
import { ElMessageBox, ElMessage } from 'element-plus';
import { uploaderKey } from '../utils/token';

import type { IFileData } from '../types';

interface FilePropsData {
  list: IFileData[];
  [k: string]: unknown;
}

export default function useFileList(props: FilePropsData) {
  const uploaderRef = inject(uploaderKey)!;
  const listRef = toRef(props, 'list');

  const handleMove = async (
    canMove: boolean,
    nextIndex: number,
    currIndex: number,
    file: IFileData,
  ) => {
    if (canMove && uploaderRef.move) {
      try {
        if (typeof uploaderRef.onMove === 'function') {
          await uploaderRef.onMove(nextIndex, currIndex, file);

          uploaderRef.emit('change', listRef.value);
        } else {
          const _list = [...listRef.value];
          const currItem = _list.splice(currIndex, 1);
          _list.splice(nextIndex, 0, currItem[0]);
          uploaderRef.emit('update:modelValue', _list);

          uploaderRef.emit('change', _list);
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleDel = async (i: number, file: IFileData) => {
    try {
      if (typeof uploaderRef.onRemove === 'function') {
        await uploaderRef.onRemove(i, file);

        uploaderRef.emit('change', listRef.value);
      } else {
        ElMessageBox.confirm('是否确认删除该文件?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            const _list = [...listRef.value];
            _list.splice(i, 1);

            uploaderRef.emit('update:modelValue', _list);

            uploaderRef.emit('change', _list);

            ElMessage.success('操作成功');
          })
          .catch(() => {});
      }
    } catch (e) {
      console.error(e);
    }
  };

  return {
    uploaderRef,
    handleDel,
    handleMove,
  };
}
